import { ReactNode } from 'react';
import { SkeletonStyles } from './SkeletonStyles';

type Props = {
  isTable?: boolean;
  columns?: number;
  rows?: number;
  html?: ReactNode[];
  height?: string;
  padding?: string;
};

const getStructure = ({
  columns = 0,
  rows = 0,
  height,
  padding,
  html = [],
  isTable,
}: Props): ReactNode => {
  if (rows === 0) return html;

  if (isTable) {
    for (let row = 0; row < rows; row++) {
      html.push(
        <tr key={row}>
          {columns ? (
            [...new Array(columns)].map((_, i) => (
              <td key={`column-${i}`} style={{ padding }}>
                <SkeletonStyles height={height} />
              </td>
            ))
          ) : (
            <SkeletonStyles height={height} />
          )}
        </tr>
      );
    }

    return html;
  }

  for (let row = 0; row < rows; row++) {
    html.push(
      <div key={row} style={{ padding }}>
        {columns ? (
          [...new Array(columns)].map((_, i) => (
            <div key={`column-${i}`}>
              <SkeletonStyles height={height} />
            </div>
          ))
        ) : (
          <SkeletonStyles height={height} />
        )}
      </div>
    );
  }

  return html;
};

export const Skeleton = ({
  columns = 0,
  rows = 0,
  isTable = true,
  padding = '5px',
  height = '50px',
}: Props) => {
  if (!columns && !rows) return <SkeletonStyles />;

  const html = getStructure({ columns, rows, height, padding, isTable });

  return <>{html}</>;
};
